import React, { useState } from 'react';
import { Mail, X, RefreshCw } from 'lucide-react';
import api from '../services/api';
import './VerificationBanner.css';

function VerificationBanner({ user, onDismiss }) {
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [dismissed, setDismissed] = useState(false);

    const handleResend = async () => {
        setLoading(true);
        setMessage('');

        try {
            await api.post('/auth/resend-verification', { email: user.email });
            setMessage('Verification email sent! Please check your inbox.');
        } catch (error) {
            setMessage(error.response?.data?.error || 'Failed to send verification email');
        } finally {
            setLoading(false);
        }
    };

    const handleDismiss = () => {
        setDismissed(true);
        if (onDismiss) onDismiss();
    };

    if (dismissed || user.isEmailVerified) {
        return null;
    }

    return (
        <div className="verification-banner">
            <div className="verification-banner-content">
                <div className="verification-banner-icon">
                    <Mail size={20} />
                </div>
                <div className="verification-banner-text">
                    <strong>Verify your email address</strong>
                    <p>
                        Please check your inbox and click the verification link we sent to{' '}
                        <strong>{user.email}</strong>
                    </p>
                    {message && (
                        <p className={`verification-message ${message.includes('sent') ? 'success' : 'error'}`}>
                            {message}
                        </p>
                    )}
                </div>
                <div className="verification-banner-actions">
                    <button
                        onClick={handleResend}
                        disabled={loading}
                        className="btn btn-ghost btn-sm"
                    >
                        <RefreshCw size={16} className={loading ? 'spinning' : ''} />
                        {loading ? 'Sending...' : 'Resend Email'}
                    </button>
                    <button
                        onClick={handleDismiss}
                        className="btn btn-ghost btn-sm btn-icon"
                        aria-label="Dismiss"
                    >
                        <X size={18} />
                    </button>
                </div>
            </div>
        </div>
    );
}

export default VerificationBanner;
